import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { GREETING_OPTIONS } from './constants';
import { PageStyles, TitleStyles } from './GreetingScreen.styles';

export const GreetingScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Greeting',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();
  const greeting = form.watch('greeting');

  const handleChange = (option: OnbOptionType<LayoutDataType['greeting']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        greeting: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles
      bgImage={
        <img
          src={`${S3_BUCKET_URL}/layout-own-ai-pool/greeting/background.jpg`}
          alt="AI Character"
        />
      }
      background="dark-solid"
    >
      <IonContent>
        <TitleStyles>
          Hey there, I'm here to check your...
          <br />
          water levels.
        </TitleStyles>
        <OnboardingOptionsList>
          {GREETING_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={greeting === option.id}
              control={form.control}
              option={option}
              name="greeting"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`greeting-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </PageStyles>
  );
};
